import React from 'react';

/**
 * Logo component for consistent logo rendering
 * 
 * @param {number} size - The size of the logo in pixels
 * @param {boolean} showText - Whether to show the text next to the logo
 * @param {string} textSize - The text size class (e.g., 'text-xl', 'text-lg')
 */
const Logo = ({ size = 40, showText = true, textSize = 'text-xl' }) => {
  // Default logo fallback for development
  const logoFallback = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Ccircle cx='20' cy='20' r='18' fill='%23C0E1F7' stroke='%230A84FF' stroke-width='2'/%3E%3Cpath d='M15 15 Q20 10, 25 15 Q30 20, 25 25 Q20 30, 15 25 Q10 20, 15 15' fill='%230A84FF'/%3E%3Ccircle cx='17' cy='17' r='2' fill='white'/%3E%3Ccircle cx='23' cy='17' r='2' fill='white'/%3E%3C/svg%3E";
  
  return (
    <div className="flex items-center">
      <img 
        src="/images/penguin-logo.svg" 
        alt="PokketCoach Logo" 
        className={`w-${size/4} h-${size/4}`}
        style={{ width: `${size}px`, height: `${size}px` }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = logoFallback;
        }}
      />
      {showText && (
        <span className={`ml-2 font-bold ${textSize}`}>PokketCoach</span>
      )}
    </div>
  );
};

export default Logo; 